module.exports = __webpack_public_path__ + "sgby/img/xiahouchun-pic.ebe3fd2.png";